<ul class="media-list media-list-divider mr-2">
    <li *ngFor="let user of trending" class="media align-items-center">
      <a class="media-img" href="javascript:;">
        <img class="img-circle" [src]="user.image" alt="image" width="54" />
      </a>
      <div class="media-body d-flex align-items-center">
        <div class="flex-1">
          <div class="media-heading">{{ user.name }}</div>
        </div>
        <div>
          <span class="badge badge-primary badge-pill">{{ user.count }}</span>
        </div>
      </div>
    </li>
  </ul>
